export const DAMAGE_COVERAGE_ACTION_COOKIE = "badi_damage_coverage";
